import React, { useEffect, useState } from "react"
import { track } from "../analytics/mixpanel"
import { ErrorBoundary } from "./ErrorBoundary"
import { ThemeProvider } from "./landing/ThemeProvider"
import { LangProvider } from "./landing/i18n/LangContext"
import { SiteNav } from "./landing/SiteNav"
import { SiteFooter } from "./landing/SiteFooter"
import { WaitlistModalProvider, useWaitlistModal } from "./landing/WaitlistModalContext"
import { WaitlistModal } from "./landing/WaitlistModal"
import { PlanCard, IntervalToggle } from "./billing/PlanCard"

// Public, logged-out pricing page (doc 10). Reuses the landing chrome
// (nav/footer/theme/waitlist modal). Plan data + labels come from the server in
// the current Rails locale.
// ponytail: card labels don't follow the JS lang switcher (nav/footer do) —
// they're server-rendered. Move copy into translations.js if that mismatch bites.
function Cards({ plans, copy }) {
  const { openModal } = useWaitlistModal()
  const [interval, setInterval] = useState("month")

  return (
    <section className="mx-auto max-w-6xl px-4 sm:px-6 py-16">
      <header className="text-center mb-10">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">{copy.title}</h1>
        <p className="mt-3 text-gray-600 dark:text-gray-400">{copy.subtitle}</p>
      </header>

      <IntervalToggle interval={interval} setInterval={setInterval} copy={copy} />

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {plans.map((plan) => (
          <PlanCard
            key={plan.key}
            plan={plan}
            interval={interval}
            copy={copy}
            cta={
              <button
                type="button"
                onClick={() => openModal("pricing")}
                className={`w-full rounded-lg px-4 py-2.5 text-center text-sm font-semibold transition-all ${
                  plan.popular ? "bg-brand-500 text-gray-900 hover:bg-brand-400" : "bg-brand-600 text-white hover:bg-brand-700"
                }`}
              >
                {plan.free ? copy.selectFree : copy.publicCta}
              </button>
            }
          />
        ))}
      </div>

    </section>
  )
}

export default function PublicPricingApp({ logoUrl, plans, copy }) {
  useEffect(() => {
    track("Pricing Viewed", { plans_shown: plans.length, interval: "month" })
  }, [plans.length])

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <LangProvider>
          <WaitlistModalProvider>
            <div className="min-h-screen bg-white dark:bg-gray-950 antialiased">
              <SiteNav logoUrl={logoUrl} />
              <main>
                <Cards plans={plans} copy={copy} />
              </main>
              <SiteFooter logoUrl={logoUrl} />
            </div>
            <WaitlistModal />
          </WaitlistModalProvider>
        </LangProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
